import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';

import './HeaderStepper.scss';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.palette.primary.main,
  },
  lightHeader: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },
  lightHeaderText: {
    color: "#000000DE !important",
  }
}));

function HeaderStepper(props) {
  const classes = useStyles();
  const title = props.title || "Let's get the best quote for you";
  const phone = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.phone;
  const dateTime = 'Monday - Friday 8:00 AM - 8:00 PM ET';

  return (
    <div className={`header-stepper ${props.whiteBg ? 'white-background' : ''} ${props.hideProgressTracker ? 'increase-contrast' : ''}`}>
      <Container fluid className={`head shadow ${props.isLightHeader ? classes.lightHeader : classes.header} ${props.hidden ? 'd-none' : ''} ${!props.hideProgressTracker ? 'extend-head' : ''}`}>
        <Container className={props.hideProgressTracker ? 'h-100' : ''}>
          <Row className={props.hideProgressTracker ? 'h-100' : ''}>
            <Col className="d-flex align-items-center h1-wrapper">
              <h1 className={props.isLightHeader ? classes.lightHeaderText : ''}>{title}</h1>
            </Col>
            { !props.hideContact && <Col className="phone">
              <div>
                <span className='account-phone'>We're here to help: </span><span className='account-phone'>{phone}</span>
              </div>
              <div className="dateTime account-phone">
                {dateTime}
              </div>
            </Col> }
            <div className="decor d-flex position-absolute">
              { !props.isLightHeader && <Image src="./circle-crop.png" alt="" /> }
            </div>
          </Row>

          {!props.hideProgressTracker &&
            <ProgressTracker {...props} />
          }

        </Container>
      </Container>

      <Container fluid className={`page-content px-0 ${props.modernizeContainer ? 'p-0' : ''} `}>
        {props.children}
      </Container>
    </div>
  );
}

function ProgressTracker(props) {
  let percentCompleted;
  if(props.percent!==undefined && props.percent>=0){
      percentCompleted=props.percent;
  }
  else if(props.firstStep){
    percentCompleted = ((props.step - 1) / props.totalSteps) * 100;
 }
  else{
    percentCompleted = ((props.step - .5) / props.totalSteps) * 100;
  } 

  if (props.lastStep) {
    percentCompleted = 100;
  }

  return (
    <Row className="progressTrackerRow">
      <Col>
        <div className="progressTracker shadow">
          <h2 className={`progressTrackerTitle ${props.hideStepsDropdown ? 'mb-4' : ''}`}>{props.stepName}</h2>
          {!props.hideStepsDropdown &&
            <p className="progressSteps">
              Step {props.step} of {props.totalSteps}
            </p>
          }
          <LinearProgress variant="determinate" value={percentCompleted} className="progress" aria-hidden="true" />
        </div>
      </Col>
    </Row>
  );
}

export { HeaderStepper };

HeaderStepper.propTypes = {
  hideProgressTracker: PropTypes.bool,
  hidden: PropTypes.bool,
  title: PropTypes.string,
  whiteBg: PropTypes.bool,
  lastStep: PropTypes.bool,
  hideContact: PropTypes.bool,
  isLightHeader: PropTypes.bool,
};

ProgressTracker.propTypes = {
  stepName: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  percent: PropTypes.number,
  firstStep: PropTypes.object,
  lastStep: PropTypes.object,
  hideStepsDropdown: PropTypes.object,

};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/HeaderStepper/HeaderStepper.js